import { render, staticRenderFns } from "./AddFacebookAds.vue?vue&type=template&id=3a506947&scoped=true&"
import script from "./AddFacebookAds.vue?vue&type=script&lang=js&"
export * from "./AddFacebookAds.vue?vue&type=script&lang=js&"
import style0 from "./AddFacebookAds.vue?vue&type=style&index=0&id=3a506947&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a506947",
  null
  
)

export default component.exports